import { create } from "zustand";
import {
  StateStorage,
  createJSONStorage,
  devtools,
  persist,
} from "zustand/middleware";

import { createAuthSlice } from "auth/store";
import { createProjectSlice } from "projects/store";
import { createSubcontractorSlice } from "subcontractors/store";
import { createUserSlice } from "users/store";
import { IAuthSlice } from "auth/models";
import { IProjectSlice } from "projects/models";
import { ISubcontractorSlice } from "subcontractors/models";
import { IUserSlice } from "users/models";
import { createOrganizationSlice } from "organizations/store";
import { IOrganizationSlice } from "organizations/models";
import { createTenantSlice } from "tenants/store";
import { ITenantSlice } from "tenants/models";

export let sliceResetFns = new Set<() => void>();
const storage: StateStorage = {
  getItem: (name: string): string | null => {
    return localStorage.getItem(name) || null;
  },
  setItem: (name: string, value: string): void => {
    localStorage.setItem(name, value);
  },
  removeItem: (name: string): void => {
    localStorage.removeItem(name);
  },
};

export const resetAllSlices = () => {
  sliceResetFns.forEach((resetFn) => {
    resetFn();
  });
};

export const useBoundStore = create<
  IAuthSlice &
  IProjectSlice &
  ISubcontractorSlice &
  IUserSlice &
  IOrganizationSlice &
  ITenantSlice
>()(
  persist(
    devtools((...a) => ({
      ...createAuthSlice(...a),
      ...createProjectSlice(...a),
      ...createSubcontractorSlice(...a),
      ...createUserSlice(...a),
      ...createOrganizationSlice(...a),
      ...createTenantSlice(...a),
    })),
    {
      name: "tracpro-storage",
      storage: createJSONStorage(() => storage),
      partialize: (state) => {
        const { isAxiosInterceptorsReady, ...rest } = state;
        return rest;
      },
    }
  )
);
